module.exports = __webpack_public_path__ + "static/img/bg-fr.4e65b701.png";